import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';

const API_BASE_URL = '/api';

export default function Login({ onLoginSuccess }) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await axios.post(
        `${API_BASE_URL}/auth/login`,
        { password },
        { withCredentials: true }
      );
      setMessage('Login successful!');
      setTimeout(() => onLoginSuccess(), 500);
    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Authentication failed';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>📱 TelegramPost</h1>
          <p>Web Interface</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="alert alert-error">❌ {error}</div>}
          {message && <div className="alert alert-success">✓ {message}</div>}

          <div className="form-group">
            <label className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              disabled={loading}
              autoFocus
            />
          </div>

          <button
            type="submit"
            className="btn btn-success"
            disabled={loading || !password}
            style={{ width: '100%' }}
          >
            {loading ? 'Processing...' : 'Login'}
          </button>
        </form>

        <div className="login-info">
          <p>Enter your password to access TelegramPost</p>
        </div>
      </div>
    </div>
  );
}
